import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "program-short-name" }
const _hoisted_2 = { class: "program-logo-row" }
const _hoisted_3 = { class: "program-logo-wrapper" }
const _hoisted_4 = ["src", "onError"]
const _hoisted_5 = {
  key: 1,
  class: "empty-hint"
}
const _hoisted_6 = { class: "program-short-name" }
const _hoisted_7 = {
  key: 0,
  class: "program-logo-row"
}
const _hoisted_8 = { class: "program-logo-wrapper program-logo-wrapper-preview" }
const _hoisted_9 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeaderWithMenu = _resolveComponent("PageHeaderWithMenu")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_PageHeaderWithMenu, {
        title: "Релизы",
        scrolled: _ctx.headerScrolled
      }, null, 8, ["scrolled"]),
      _createVNode(_component_ion_content, {
        class: _normalizeClass([_ctx.isMobile ? 'main-background' : 'liga-web-background']),
        fullscreen: true,
        onIonScroll: _ctx.onContentScroll
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_card, { class: "admin-card" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_content, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    expand: "block",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openNewProgramModal()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "start",
                        icon: _ctx.add
                      }, null, 8, ["icon"]),
                      _cache[19] || (_cache[19] = _createTextVNode(" Создать новую программу ", -1))
                    ]),
                    _: 1
                  }),
                  (_ctx.showGoogleDriveSyncButton)
                    ? (_openBlock(), _createBlock(_component_ion_button, {
                        key: 0,
                        expand: "block",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.syncWithGoogleDrive())),
                        disabled: _ctx.syncing
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "start",
                            icon: _ctx.cloudDownloadOutline
                          }, null, 8, ["icon"]),
                          _createTextVNode(" " + _toDisplayString(_ctx.syncing ? 'Синхронизация...' : 'Синхронизировать с Google Drive'), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.programs, (program) => {
            return (_openBlock(), _createBlock(_component_ion_card, {
              class: "admin-card",
              key: program.id
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_card_header, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(program.programName), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createElementVNode("p", _hoisted_1, _toDisplayString(program.shortName), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_ion_card_content, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("img", {
                          src: _ctx.programLogoUrl(program.shortName),
                          alt: "Логотип программы",
                          class: "program-logo-img",
                          onError: ($event: any) => (_ctx.onLogoError(program.shortName))
                        }, null, 40, _hoisted_4)
                      ]),
                      _createVNode(_component_ion_button, {
                        fill: "clear",
                        size: "small",
                        class: "program-logo-edit-btn",
                        onClick: ($event: any) => (_ctx.openLogoModal(program))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "start",
                            icon: _ctx.imageOutline
                          }, null, 8, ["icon"]),
                          _cache[20] || (_cache[20] = _createTextVNode(" Изменить ", -1))
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _createVNode(_component_ion_button, {
                      expand: "block",
                      onClick: ($event: any) => (_ctx.openNewReleaseModal(program))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, {
                          slot: "start",
                          icon: _ctx.add
                        }, null, 8, ["icon"]),
                        _cache[21] || (_cache[21] = _createTextVNode(" Создать релиз ", -1))
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    (program.fullReleases && program.fullReleases.length)
                      ? (_openBlock(), _createBlock(_component_ion_list, { key: 0 }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(program.fullReleases, (release) => {
                              return (_openBlock(), _createBlock(_component_ion_item, {
                                key: release.id,
                                detail: false,
                                button: "",
                                onClick: ($event: any) => (_ctx.openReleaseContent(release))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h2", null, _toDisplayString(program.programName) + " " + _toDisplayString(release.releaseName), 1),
                                      _createElementVNode("p", null, _toDisplayString(release.visible ? 'Видимый' : 'Скрытый'), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_ion_icon, {
                                    slot: "end",
                                    icon: _ctx.chevronForward
                                  }, null, 8, ["icon"])
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1024))
                      : (_openBlock(), _createElementBlock("p", _hoisted_5, "Нет релизов для этой программы."))
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128)),
          _createVNode(_component_ion_modal, {
            "is-open": _ctx.showNewProgramModal,
            onDidDismiss: _cache[6] || (_cache[6] = ($event: any) => (_ctx.closeNewProgramModal())),
            class: "admin-releases-modal"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_toolbar, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_title, null, {
                        default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                          _createTextVNode("Новая программа", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_ion_buttons, { slot: "end" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_button, {
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeNewProgramModal()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, { icon: _ctx.closeOutline }, null, 8, ["icon"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_content, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_header, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_title, null, {
                            default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                              _createTextVNode("Создать программу", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_card_content, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_input, {
                                label: "Название программы",
                                "label-placement": "stacked",
                                modelValue: _ctx.newProgramName,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newProgramName) = $event)),
                                placeholder: "Например: HypeDance"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_input, {
                                label: "Короткое название (латиницей)",
                                "label-placement": "stacked",
                                modelValue: _ctx.newProgramShortName,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newProgramShortName) = $event)),
                                placeholder: "Например: HD"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_button, {
                            expand: "block",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.createNewProgram())),
                            disabled: !_ctx.newProgramName || !_ctx.newProgramShortName || _ctx.creatingProgram
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.creatingProgram ? 'Создание...' : 'Создать программу'), 1)
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["is-open"]),
          _createVNode(_component_ion_modal, {
            "is-open": _ctx.showNewReleaseModal,
            onDidDismiss: _cache[12] || (_cache[12] = ($event: any) => (_ctx.closeNewReleaseModal())),
            class: "admin-releases-modal"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_toolbar, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_title, null, {
                        default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                          _createTextVNode("Новый релиз", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_ion_buttons, { slot: "end" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_button, {
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.closeNewReleaseModal()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, { icon: _ctx.closeOutline }, null, 8, ["icon"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_content, null, {
                default: _withCtx(() => [
                  (_ctx.selectedProgram)
                    ? (_openBlock(), _createBlock(_component_ion_card, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_header, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_title, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.selectedProgram.programName), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_content, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_input, {
                                    label: "Номер релиза",
                                    "label-placement": "stacked",
                                    modelValue: _ctx.newReleaseName,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newReleaseName) = $event)),
                                    placeholder: "Например: 1 или 10"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_input, {
                                    label: "Описание (опционально)",
                                    "label-placement": "stacked",
                                    modelValue: _ctx.newReleaseDescription,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.newReleaseDescription) = $event)),
                                    placeholder: "Описание релиза"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_toggle, {
                                    modelValue: _ctx.newReleaseVisible,
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.newReleaseVisible) = $event))
                                  }, {
                                    default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                                      _createTextVNode("Видимый для всех пользователей", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_button, {
                                expand: "block",
                                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.createNewRelease())),
                                disabled: !_ctx.newReleaseName || _ctx.creating
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.creating ? 'Создание...' : 'Создать'), 1)
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["is-open"]),
          _createVNode(_component_ion_modal, {
            "is-open": _ctx.showLogoModal,
            onDidDismiss: _cache[18] || (_cache[18] = ($event: any) => (_ctx.closeLogoModal())),
            class: "admin-releases-modal"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_toolbar, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_title, null, {
                        default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                          _createTextVNode("Логотип программы", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_ion_buttons, { slot: "end" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_button, {
                            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.closeLogoModal()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, { icon: _ctx.closeOutline }, null, 8, ["icon"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_ctx.logoModalProgram)
                ? (_openBlock(), _createBlock(_component_ion_content, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card, { class: "admin-card" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_header, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_title, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.logoModalProgram.programName), 1)
                                ]),
                                _: 1
                              }),
                              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.logoModalProgram.shortName), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_content, null, {
                            default: _withCtx(() => [
                              (_ctx.logoModalProgram.shortName)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                    _createElementVNode("div", _hoisted_8, [
                                      _createElementVNode("img", {
                                        src: _ctx.programLogoUrl(_ctx.logoModalProgram.shortName),
                                        alt: "Логотип",
                                        class: "program-logo-img",
                                        onError: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onLogoError(_ctx.logoModalProgram.shortName)))
                                      }, null, 40, _hoisted_9)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("input", {
                                type: "file",
                                ref: "logoFileInput",
                                accept: "image/png,image/jpeg,image/jpg",
                                style: {"display":"none"},
                                onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onLogoFileSelected($event)))
                              }, null, 544),
                              _createVNode(_component_ion_button, {
                                expand: "block",
                                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.triggerLogoFileInput())),
                                disabled: _ctx.logoUploading
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "start",
                                    icon: _ctx.imageOutline
                                  }, null, 8, ["icon"]),
                                  _createTextVNode(" " + _toDisplayString(_ctx.logoUploading ? 'Загрузка...' : 'Выбрать файл (PNG, JPG)'), 1)
                                ]),
                                _: 1
                              }, 8, ["disabled"]),
                              _createVNode(_component_ion_button, {
                                expand: "block",
                                fill: "outline",
                                color: "danger",
                                class: "ion-margin-top",
                                onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.removeProgramLogo())),
                                disabled: _ctx.logoDeleting || !_ctx.logoHasFile(_ctx.logoModalProgram.shortName)
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "start",
                                    icon: _ctx.trashOutline
                                  }, null, 8, ["icon"]),
                                  _createTextVNode(" " + _toDisplayString(_ctx.logoDeleting ? 'Удаление...' : 'Удалить логотип'), 1)
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["is-open"])
        ]),
        _: 1
      }, 8, ["class", "onIonScroll"])
    ]),
    _: 1
  }))
}